(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-kibana"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-kibana"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-kibana.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-kibana.js":
/*!***********************************!*\
  !*** ./src/mggp-plugin-kibana.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Applicable log levels
 * @type {Array}
 */
var LEVELS = ['DEBUG', 'WARNING', 'ERROR', 'PLAYER_WARNINGS', 'P2P'];

/**
 * @class MggpPluginKibana
 */

var MggpPluginKibana = function (_Plugin) {
  _inherits(MggpPluginKibana, _Plugin);

  /**
   *
   */
  function MggpPluginKibana() {
    var _ref;

    _classCallCheck(this, MggpPluginKibana);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = MggpPluginKibana.__proto__ || Object.getPrototypeOf(MggpPluginKibana)).call.apply(_ref, [this].concat(args)));

    if (!_this.config.kibana || !_this.config.kibana.events) return _possibleConstructorReturn(_this);

    _this.namespace = 'kibana:';

    _this.player.on(_this.namespace + '*', function (event) {
      var parts = event.name.split(':').splice(1);
      var level = parts[0].toUpperCase();
      var name = parts.join(':');
      var protocol = _this.config.protocol.replace(':', '');
      var url = _this.config.kibana.events[protocol][name];

      if (LEVELS.indexOf(level) === -1 || !url) return;

      _this._send(url, level, {
        text: event.data.type || event.data.name,
        data: JSON.stringify(event.data)
      });
    });
    return _this;
  }
  /**
   * Send notification
   * @param  {string} url an URL to post to
   * @param  {string} level log level
   * @param  {object} event
   */


  _createClass(MggpPluginKibana, [{
    key: '_send',
    value: function _send(url, level, data) {
      var _this2 = this;

      if (this._wait) return;

      this._wait = true;
      setTimeout(function () {
        return _this2._wait = false;
      }, this.config.delay || 0);

      var xhr = new XMLHttpRequest();

      xhr.onreadystatechange = function () {
        if (_this2.readyState !== 4) return;
        _this2.emit('debug', { message: xhr.statusText });
      };

      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.send(this._encode(data));
    }
  }, {
    key: '_encode',
    value: function _encode(data) {
      var result = [],
          i,
          keys;

      // input plain object validation
      if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        keys = Object.keys(data);

        // apply encoding
        for (i = 0; i < keys.length; i++) {
          result.push(encodeURIComponent(keys[i]) + '=' + encodeURIComponent(data[keys[i]]));
        }

        // build the list of params
        if (result.length > 0) {
          return result.join('&');
        }
      }

      return null;
    }
  }]);

  return MggpPluginKibana;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginKibana;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});